/* Adapter for .amp's no-store product-tag lookup. Product/catalog data stays unchanged.
   Keep this before the app embed: it evaluates the returned tags before mounting. */
(() => {
  const originalFetch = window.fetch.bind(window);
  const targetPath = /\/products\/ct1000-25-gr\.js$/;
  const skus = new Set(['CT1000-25-GR', 'CT1000-25-BL']);
  const blockedTags = new Set(['配送希望日時指定不可', '日時指定不可']);
  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);
    const url = new URL(input instanceof URL ? input.href : typeof input === 'string' ? input : input.url, location.origin);
    // Re-mount the delivery app after a successful quantity change on the cart page.
    if (url.origin === location.origin && /\/cart\/change(?:\.js)?$/.test(url.pathname) && /\/cart\/?$/.test(location.pathname) && response.ok) {
      response.clone().json().then((cart) => {
        if (Array.isArray(cart.items)) setTimeout(() => location.reload(), 150);
      }).catch(() => {});
    }
    if (url.origin !== location.origin || !targetPath.test(url.pathname) || init?.cache !== 'no-store' || !response.ok) return response;
    try {
      const cartResponse = await originalFetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
      if (!cartResponse.ok) return response;
      const cart = await cartResponse.json();
      const count = cart.items.reduce((sum, item) => sum + (skus.has(item.sku) ? item.quantity : 0), 0);
      if (count > 10) return response;
      const product = await response.clone().json();
      if (!Array.isArray(product.tags)) return response;
      product.tags = product.tags.filter((tag) => !blockedTags.has(tag));
      const headers = new Headers(response.headers);
      headers.delete('content-length');
      headers.delete('content-encoding');
      return new Response(JSON.stringify(product), { status: response.status, statusText: response.statusText, headers });
    } catch (_) {
      // Keep the existing delivery restriction if a fresh cart cannot be verified.
      return response;
    }
  };
})();

// Mark the prefecture guidance as a note, including after app re-renders.
(() => {
  const markNote = () => {
    const form = document.querySelector('form.form-cart');
    const checkout = form?.querySelector('.cart-delivery-datetime_checkout-wrapper button[name="checkout"]');
    const note = form?.querySelector('textarea[name="note"][id$="_mobile"]')?.closest('.ug-cart-order-note, .input-show');
    if (checkout && note && checkout.previousElementSibling !== note) {
      checkout.before(note);
      note.classList.add('ug-delivery-order-note');
    }

    document.querySelectorAll('.statement__wrapper--warning .statement__wrapper__title-block p').forEach((node) => {
      const text = node.textContent.trim();
      if (text.startsWith('都道府県を選択後に')) node.prepend('※');
    });
  };
  const start = () => {
    markNote();
    new MutationObserver(markNote).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
